export default __webpack_public_path__ + "f5ea8526674604b3eacab3ea5b04d9a7.svg";